import { Component, Input } from '@angular/core';
import { isEmpty } from 'underscore';

import { SpinnerState } from 'rev-shared/ui/spinner/Spinner';

import { WebcastModel } from '../model/WebcastModel';
import styles from './LiveStreamStatus.Component.module.less';

@Component({
	selector: 'live-stream-status',
	templateUrl: './LiveStreamStatus.Component.html',
	host: {
		'[class]': 'styles.root'
	},
	standalone: false
})
export class LiveStreamStatusComponent {
	@Input() public webcast: WebcastModel;

	public SpinnerState = SpinnerState;

	public readonly styles = styles;

	public get webrtcSiglePresenterWaitingForStream(): boolean {
		return this.webcast.isWebrtcSinglePresenter && !this.webcast.vcStatus.isInitializing && !isEmpty(this.webcast.vcStatus);
	}
}
